import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor(private apiBaseService: ApiBaseService) { }

  async getSiteIdByProjectId(payload: any): Promise<any> {
    return this.apiBaseService.httpRequest('UtilitiesService/GetSiteIdByProjectId', payload, true, true);
  }

  async getProjectIdsBySiteId(payload: any): Promise<any> {
    return this.apiBaseService.httpRequest('UtilitiesService/GetProjectIdsBySiteId', payload, true, true);
  }
}
